
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError, TimeoutError } from 'rxjs';
import { catchError, filter, finalize, map, tap, timeout } from 'rxjs/operators';
import { NgxUiLoaderService, Loader } from 'ngx-ui-loader';
import { BaseService } from 'src/app/infrastructure/infrastructure-services/services/base/base-service';
import { GlobalProperties } from 'src/app/global/global-properties';
import { DataService } from 'src/app/shared/constants/data.service';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {

  
    constructor(private ngxUiLoaderService: NgxUiLoaderService, public snackbarService: BaseService<any>,private dataService:DataService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const isSapUrl = request.url.startsWith(`${GlobalProperties._apiUrlSap}`);
      
        let isAttachment:any;
        if(isSapUrl)
      {   isAttachment = request.url.includes("Attachments2");}
        return next.handle(request).pipe(
            tap({
                next: (event: HttpEvent<any>) => {
                     
                    if (event instanceof HttpResponse) {
                        if(isAttachment){
                          if (event.status === 201) {
                                this.snackbarService.showMessage('Uploaded Successfully', 'X');
                                return;
                            }
                            else if (event.status === 204) {
                                this.snackbarService.showMessage('Updated Successfully', 'X');
                                return;
                            }
                        }
                        if (isSapUrl) {
                            if (event.status === 201) {
                                this.snackbarService.showMessage('Created Successfully', 'X');
                            }
                            else if (event.status === -2038) {
                                this.snackbarService.showMessage('Created Successfully', 'X');
                            }
                            else if (event.status === 204) {
                                this.snackbarService.showMessage('Updated Successfully', 'X');
                            }
                          
                        }
                    }
                },
                error: (error) => {
                 
                   if(error.status==401){

                    this.ngxUiLoaderService.stop()
                    this.snackbarService.showMessage('Invalid Login Credentials', 'X');
                  
                   }
                  
                   
                }
            })
        );
    }


  

}